import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import AbnormalReceivingOrderList from '../entities/back-abnormalreceivingorder-list'

interface AbnormalReceivingOrderState extends ListState<AbnormalReceivingOrderList> {

}

class AbnormalReceivingOrderMutations extends ListMutations<AbnormalReceivingOrderList>{

}
class AbnormalReceivingOrder extends ListModule<AbnormalReceivingOrderState, any, AbnormalReceivingOrderList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<AbnormalReceivingOrderList>(),
        loading: false,
    }
    actions = {
        async getAll(context: ActionContext<AbnormalReceivingOrderState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/BackOrder/GetAbnormalReceivingOrderList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<AbnormalReceivingOrderList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },

    };
    mutations = {
        setCurrentPage(state: AbnormalReceivingOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: AbnormalReceivingOrderState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const abnormalreceivingorder = new AbnormalReceivingOrder();
export default abnormalreceivingorder;